/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * Badge.tsx — Badge (services/operator-web-app).
 */

import type { ReactNode } from 'react';

type BadgeVariant =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'neutral'
  | 'callActive'
  | 'callHeld'
  | 'callCritical';

export interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
  title?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  success: 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30',
  warning: 'bg-amber-500/20 text-amber-300 border border-amber-500/30',
  danger: 'bg-red-500/20 text-red-300 border border-red-500/30',
  info: 'bg-sky-500/20 text-sky-300 border border-sky-500/30',
  neutral: 'bg-white/10 border border-white/10',
  callActive: 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30',
  callHeld: 'bg-amber-500/20 text-amber-300 border border-amber-500/30',
  callCritical: 'bg-red-500/20 text-red-300 border border-red-500/30',
};

export function Badge({ variant = 'neutral', children, className = '', title }: BadgeProps) {
  const classes = [
    'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium backdrop-blur-sm',
    variantClasses[variant],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} title={title} style={variant === 'neutral' ? { color: 'var(--text-muted)' } : undefined}>
      {children}
    </span>
  );
}
